import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import OkCancelModal from '@/shared/components/OkCancelModal';
import intlShape from '@/shared/utils/intlShape';
import messages from '../documentMessages';

export default class SelectRelationModal extends Component {
  state = {
    selectedRelation: undefined,
  };

  static propTypes = {
    show: PropTypes.bool.isRequired,
    intl: intlShape.isRequired,
    onSave: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    relations: PropTypes.arrayOf({}).isRequired,
  };

  static defaultProps = {};

  componentDidMount() {
    const { relations } = this.props;
    this.setState({ selectedRelation: relations[0] });
  }

  onSave = () => {
    const { selectedRelation } = this.state;
    const { onSave } = this.props;

    return onSave(selectedRelation);
  };

  closeModal = () => {
    const { onClose } = this.props;
    onClose();
  };

  render() {
    const { show, intl, relations } = this.props;
    const { selectedRelation } = this.state;
    if (!show) return null;

    return (
      <OkCancelModal
        title={intl.formatMessage(messages.SelectRelation)}
        show={show}
        onClose={this.closeModal}
        disabled={false}
        onSave={this.onSave}
      >
        <div className="form-horizontal">
          <div>
            <div className="form-group">
              <label className="control-label col-md-3">
                <FormattedMessage {...messages.SelectRelation} />
              </label>
              <div className="col-md-9" style={{ marginTop: '7px' }}>
                <select
                  className="form-control"
                  value={selectedRelation?.id}
                  onChange={e =>
                    this.setState({
                      selectedRelation: relations.find(x => x.id === e.target.value),
                    })
                  }
                >
                  {relations.map(x => (
                    <option key={x.id} value={x.id}>
                      {x.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </div>
      </OkCancelModal>
    );
  }
}
